/*
 * ****************************************************************
 * File: navbar.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Prathik Pai
 *
 * ****************************************************************
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Main from "../../routes";
import { BrowserRouter, withRouter, useHistory } from "react-router-dom";
import AppBarTop from "../../components/AppBar";

const useStyles = makeStyles({
  dialog: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    bottom: 5,
    right: 5,
    color: "white",
    height: "300px",
    width: "320px",
    margin: 0,
  },
  ibuttonclose: {
    color: "tomato",
    width: 40,
    height: 40,
    margin: "0.5rem",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    flexGrow: 1,
  },
});

const Home = ({
  debugLogs,
  connection,
  session,
  makeCall,
  acceptCall,
  endCall,
  remoteURI,
  setRemoteURI,
  logoutClient,
  devices,
  onDeviceSelected,
  RTCUtils,
  setUpgrade,
  upgrade,
  localStream,
  remoteStream,
  engageClient,
  readyEvent,
  test,
  resolutionData,
  collocation,
  setCollocation,
  conferenceLayout,
  setConferenceLayout,
  onLayoutChange,
  setCallDate,
  onStartTranscribe,
  onStopTranscribe,
  toggleTranscribe,
  setToggleTranscribe
}) => {
  const history = useHistory();
  const classes = useStyles();

  const onLogout = () => {
    if (session.session) {
      if (session.incoming && session.ringing) {
        session.session.rejectCall();
      } else {
        session.session.disconnectCall();
      }
    }
    logoutClient();
    history.push("/");
  };

  useEffect(() => {
    if (engageClient == null) {
      history.push("/");
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#F1F5F8",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        overflow: "auto",
      }}
    >
      <div data-testid="onLogout" onClick={onLogout}></div>
      <AppBarTop
        readyEvent={readyEvent}
        test={test}
        upgrade={upgrade}
        setUpgrade={setUpgrade}
        session={session}
        onLogout={onLogout}
        devices={devices}
        onDeviceSelected={onDeviceSelected}
        RTCUtils={RTCUtils}
        connection={connection}
        debugLogs={debugLogs}
        engageClient={engageClient}
        resolutionData={resolutionData}
        makeCall={makeCall}
        conferenceLayout={conferenceLayout}
        setConferenceLayout={setConferenceLayout}
        onLayoutChange={onLayoutChange}
        onStartTranscribe={onStartTranscribe}
        onStopTranscribe={onStopTranscribe}
        toggleTranscribe={toggleTranscribe}
      />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <BrowserRouter>
          <Main
            collocation={collocation}
            setCollocation={setCollocation}
            upgrade={upgrade}
            remoteURI={remoteURI}
            setRemoteURI={setRemoteURI}
            session={session}
            makeCall={makeCall}
            acceptCall={acceptCall}
            endCall={endCall}
            debugLogs={debugLogs}
            connection={connection}
            localStream={localStream}
            remoteStream={remoteStream}
            engageClient={engageClient}
            conferenceLayout={conferenceLayout}
            setCallDate={setCallDate}
            toggleTranscribe={toggleTranscribe}
            setToggleTranscribe={setToggleTranscribe}
          />
        </BrowserRouter>
      </main>
    </div>
  );
};

Home.propTypes = {
  RTCUtils: PropTypes.any,
  devices: PropTypes.any,
  onDeviceSelected: PropTypes.any,
  debugLogs: PropTypes.any,
  connection: PropTypes.object.isRequired,
  session: PropTypes.any,
  makeCall: PropTypes.any,
  acceptCall: PropTypes.any,
  logoutClient: PropTypes.func,
  endCall: PropTypes.any,
  connect: PropTypes.any,
  remoteURI: PropTypes.string.isRequired,
  setRemoteURI: PropTypes.func.isRequired,
  connectionStatusColor: PropTypes.object.isRequired,
  setUpgrade: PropTypes.any,
  upgrade: PropTypes.any,
  remoteStream: PropTypes.any,
  localStream: PropTypes.any,
  engageClient: PropTypes.any,
  readyEvent: PropTypes.bool,
  onLogoutHandler: PropTypes.func,
  onLogout: PropTypes.func,
  test: PropTypes.any,
  resolutionData: PropTypes.any,
  collocation: PropTypes.any,
  setCollocation: PropTypes.any,
  conferenceLayout: PropTypes.any,
  setConferenceLayout: PropTypes.any,
  onLayoutChange: PropTypes.any,
  setCallDate: PropTypes.any,
  onStartTranscribe: PropTypes.any,
  onStopTranscribe: PropTypes.any,
  toggleTranscribe: PropTypes.any,
  setToggleTranscribe: PropTypes.any
};

export default withRouter(Home);
